
const carouselWrapper = document.getElementById("more-colours--wrapper-carousel")
   var swatchCarousel = new Swiper(carouselWrapper, {
    slidesPerView: 4,
    horizontal: true,
    speed: 300,
    initialSlide: 0,
     slidesPerGroup: 1,
     spaceBetween: 0,
     navigation: {
       nextEl: `.swatches_swiper-button-next`,
       prevEl: `.swatches_swiper-button-prev`,
     },
     loop: true,
     on: {
      afterInit: function(e) {
      $('.swiper-slide').css('display','block');
      },
      realIndexChange: function(e) {
      }
     },
     breakpoints: {
       0: {
         speed: 250,
         navigation: {
           nextEl: `.swatches_swiper-button-next`,
           prevEl: `.swatches_swiper-button-prev`,
         },
         slidesPerView: 4,
         spaceBetween: 5
       },
       900: {
         effect: "none",
         navigation: {
           nextEl: `.swatches_swiper-button-next`,
           prevEl: `.swatches_swiper-button-prev`,
         },
         speed: 300,
         spaceBetween: 10,
         slidesPerView: 4,
         centeredSlides: false
       }
     }
  });



